import PersonalInformation from "./components/PersonalInformation";
import GovernmentInformation from "./components/GovernmentInformation";
import TaxpayerInformation from "./components/TaxpayerInformation";
import ContactInformation from "./components/ContactInformation";
import AddressInformation from "./components/AddressInformaton";
import SpouseInformation from "./components/SpouseInformation";
import ParentsInformation from "./components/ParentsInformation";

const BasicInformation = ({ id, data, isLoading, onRefresh }) => {
  return (
    <div className="card">
      <div className="px-5">
        <PersonalInformation
          data={data}
          isLoading={isLoading}
          onRefresh={onRefresh}
        />
        <ContactInformation
          data={data}
          isLoading={isLoading}
          onRefresh={onRefresh}
        />
        <AddressInformation id={id} />
        <SpouseInformation id={id} />
        <ParentsInformation id={id} />
        <GovernmentInformation
          data={data}
          isLoading={isLoading}
          onRefresh={onRefresh}
        />
        <TaxpayerInformation id={id} />
      </div>
    </div>
  );
};

export default BasicInformation;
